import React from 'react';
import { Ic } from './Icons';
import { BG } from '../lib/tokens';
import LogisticsScreen from '../screens/LogisticsScreen';
import CommitmentsScreen from '../screens/CommitmentsScreen';
import ResourcesScreen from '../screens/ResourcesScreen';
import PostEventScreen from '../screens/PostEventScreen';
import AdminScreen from '../screens/AdminScreen';
import UploadsScreen from '../screens/UploadsScreen';

const TITLES = {
  logistics: 'Logistics',
  commitments: 'Commitments',
  resources: 'Resources',
  uploads: 'Uploads & Links',
  'post-event': 'Post-Event',
  admin: 'Admin',
};

export default function MenuScreenView({ screen, onBack, isPostEvent, setIsPostEvent }) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: BG,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 10,
        paddingTop: 'env(safe-area-inset-top, 0px)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '14px 18px',
          flexShrink: 0,
          borderBottom: '1px solid rgba(255,255,255,0.07)',
        }}
      >
        <button
          onClick={onBack}
          aria-label="Back"
          style={{
            background: 'rgba(255,255,255,0.07)',
            border: 'none',
            cursor: 'pointer',
            width: 34,
            height: 34,
            borderRadius: 9,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Ic.ArrowLeft size={18} color="#fff" />
        </button>
        <span
          style={{ fontSize: 17, fontWeight: 700, color: '#fff', letterSpacing: '-0.01em' }}
        >
          {TITLES[screen]}
        </span>
      </div>
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {screen === 'logistics' && <LogisticsScreen />}
        {screen === 'commitments' && <CommitmentsScreen />}
        {screen === 'resources' && <ResourcesScreen />}
        {screen === 'uploads' && <UploadsScreen />}
        {screen === 'post-event' && <PostEventScreen isPostEvent={isPostEvent} />}
        {screen === 'admin' && (
          <AdminScreen isPostEvent={isPostEvent} setIsPostEvent={setIsPostEvent} />
        )}
      </div>
    </div>
  );
}
